import { render, staticRenderFns } from "./AssetReviewDetails.vue?vue&type=template&id=76cab356&scoped=true"
import script from "./AssetReviewDetails.vue?vue&type=script&lang=js"
export * from "./AssetReviewDetails.vue?vue&type=script&lang=js"
import style0 from "./AssetReviewDetails.vue?vue&type=style&index=0&id=76cab356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cab356",
  null
  
)

export default component.exports